import React from "react";
import Dispatcher from "../../dispatcher";
import ModalStore from "../../stores/modal-store";
import RedeemCode from "../resources/redeem-code";
import ManageHighlighters from "../resources/manage-highlighters";
import EnhancedFormattingFeedback from "../resources/enhanced-formatting-feedback";
import CopyURL from "../resources/copy-url";
import Citations from "../resources/citations";
import GiveFeedback from "../resources/feedback-form";
import InstructorModal from "../resources/instructor-modal";
import LearnerModal from "../resources/learner-modal";
import FigurePicker from "../resources/figure-picker";

class ModalManager extends React.Component {
  constructor() {
    super();
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    Dispatcher.bind(Dispatcher.MODAL_STORE_CHANGE, this.update);
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.MODAL_STORE_CHANGE, this.update);
  }

  update() {
    this.forceUpdate();
  }

  renderComponent(openModalId, data) {
    switch (openModalId) {
      case "redeem-code":
        return <RedeemCode {...data} />;
      case "manage-highlighters":
        return <ManageHighlighters {...data} />;
      case "copy-url":
        return <CopyURL {...data} />;
      case "citations":
        return <Citations {...data} />;
      case "give-feedback":
        return <GiveFeedback />;
      case "enhanced-formatting-feedback":
        return <EnhancedFormattingFeedback {...data} />
      case "auto-sharing-instructor":
        return <InstructorModal closeModal={() => Dispatcher.emit(Dispatcher.CLOSE_MODAL)} />;
      case "auto-sharing-learner":
        return <LearnerModal closeModal={() => Dispatcher.emit(Dispatcher.CLOSE_MODAL)}/>
      case "flashcard-figure-picker":
        return <FigurePicker {...data} />;
    }
  }

  render() {
    const openModalId = ModalStore.openModal();
    const getModalData = ModalStore.getData();
    if (openModalId) {
      return this.renderComponent(openModalId, getModalData);
    }
    return null;
  }
}

export default ModalManager;
